/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { ModelTreeNode } from '../../modelConfiguration/data/modelOptionsTree';
import { TreeSelections } from '../../modelConfiguration/data/treeSelection';
import { ModelConfigurationLinearNode } from './modelConfigurationLinearNode';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';
import { SLTXUtil } from '../../fileFormats/sltx/sltxUtil';

interface ModelConfigurationLinearNodeContainerProps {
  node: ModelTreeNode;
  treeSelectionState: TreeSelections;
  updateTreeSelectionState: (selection: TreeSelections) => void;
  updateOptionSelection: (groupID: number, optionID: number) => void;
  getResourcePath: (path: string) => string;
  languageSelected: string;
}

function hasValidFolderPrefix(name: string): boolean {
  const idx = name.indexOf(SLTXUtil.OptionSectionSeparator);
  // must have one '.', not at start/end
  return idx > 0 && idx < name.length - 1;
}

function getFolderName(node: ModelTreeNode, languageSelected: string): string {
  const { name } = node;
  const idx = name.indexOf(SLTXUtil.OptionSectionSeparator);
  const rawFolderName = idx > 0 ? name.slice(0, idx).trim() : '';
  const tagString = CatalogTagsTranslation.getTranslation(node.tagTranslationSection, languageSelected) || rawFolderName;
  return tagString;
}

export function ModelConfigurationLinearNodeContainer({
  node,
  treeSelectionState,
  updateTreeSelectionState,
  updateOptionSelection,
  getResourcePath,
  languageSelected,
}: ModelConfigurationLinearNodeContainerProps): JSX.Element {
  const renderChild = (child: ModelTreeNode): JSX.Element => (
    <ModelConfigurationLinearNode
      key={child.path ?? child.name} // prefer something stable if available
      node={child}
      pathParent={node.path}
      pathNode={child.path}
      treeSelectionState={treeSelectionState}
      updateTreeSelectionState={updateTreeSelectionState}
      updateOptionSelection={updateOptionSelection}
      getResourcePath={getResourcePath}
      languageSelected={languageSelected}
    />
  );

  if (node.singleOptionParent) {
    return <div />;
  }

  const children = node.children ?? [];

  // Rule: if single child, keep old render no matter what
  const isSingleChild = children.length <= 1;

  // Rule: only split if ALL children have a folder prefix
  const allHaveFolders = !isSingleChild && children.length > 0 && children.every((c) => hasValidFolderPrefix(c.name));

  // Old render (unchanged)
  if (!allHaveFolders) {
    return <div className="node-container">{children.map(renderChild)}</div>;
  }

  // Group children by folder
  const folderOrder: string[] = [];
  const groups = new Map<string, ModelTreeNode[]>();

  for (const child of children) {
    const folder = getFolderName(child, languageSelected);
    if (!groups.has(folder)) {
      groups.set(folder, []);
      folderOrder.push(folder);
    }
    groups.get(folder)!.push(child);
  }

  return (
    <div className="node-container">
      {folderOrder.map((folder) => (
        <div key={folder} className="container">
          <div className="node-folder-title">{folder}</div>
          <div className="node-container">{groups.get(folder)!.map(renderChild)}</div>
        </div>
      ))}
    </div>
  );
}
